import { PropsWithChildren, useEffect } from 'react';
import {
  MotionConfig as FramerMotionConfig,
  MotionGlobalConfig,
} from 'motion/react';
import { cn } from '@/utils/shadcn';

const MotionConfig = ({
  children,
  shouldSkipAnimations,
}: PropsWithChildren<{ shouldSkipAnimations: boolean }>) => {
  MotionGlobalConfig.skipAnimations = shouldSkipAnimations;
  useEffect(() => {
    const reduce = window.matchMedia(
      `(prefers-reduced-motion: reduce)`,
    ).matches;
    MotionGlobalConfig.skipAnimations = reduce;
    MotionGlobalConfig.instantAnimations = reduce;
  }, []);
  return (
    <div
      className={cn('h-full w-full relative', {
        'no-transitions': shouldSkipAnimations,
      })}
      id={'app-root'}
    >
      <FramerMotionConfig
        reducedMotion={shouldSkipAnimations ? 'always' : 'user'}
        transition={
          shouldSkipAnimations
            ? { type: false }
            : {
                ease: 'easeOut',
                duration: 0.18,
              }
        }
      >
        {children}
      </FramerMotionConfig>
    </div>
  );
};

export { MotionConfig };
